// extracted by mini-css-extract-plugin
module.exports = {"playerWrap":"VideoPlayer_playerWrap_3_rYH","videoPlayer":"VideoPlayer_videoPlayer_2Pjvo"};